<template>
  <div>
    {{ value.form.name }}
    <small class="text-muted" v-if="value.contact">
      by
      <span class="text-body">
        {{ value.contact.firstName }} {{ value.contact.lastName }}
      </span>
      ({{ value.contact.account.name }})
    </small>
    <b-button
      @click="details = !details"
      size="sm"
      variant="link"
      class="gid-feed__details p-0 align-baseline"
    >
      <small v-if="!details">show details</small>
      <small v-else>hide details</small>
    </b-button>
    <b-collapse v-model="details" class="mt-2">
      <b-spinner v-if="loading" small></b-spinner>
      <form-answers v-else-if="formData" :answers="formData" />
    </b-collapse>
  </div>
</template>

<script>
import axios from 'axios';
import { CondOperator, RequestQueryBuilder } from '@dataui/crud-request';
import { mapGetters } from 'vuex';
import FormAnswers from '@gid/vue-common/components/inputs/FormAnswers.vue';

export async function fetchSubmissions({ job: { sfid: jobSfid } }) {
  const query = RequestQueryBuilder.create()
    .search({ 'job.id': { [CondOperator.EQUALS]: jobSfid } })
    .query();
  return await axios
    .get(`/data-api/entity/submission/?${query}`)
    .then(({ data }) =>
      data.map((value) => ({
        time: new Date(value.createdAt),
        value,
      })),
    );
}

export default {
  components: {
    FormAnswers,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      details: false,
      formData: null,
      loading: false,
    };
  },
  watch: {
    details(value) {
      if (value && this.formData === null && !this.loading) {
        this.loading = true;
        axios
          .get(
            `/order-intake-forms-api/form/answers/${this.value.job.apiId}?submission-id=${this.value.id}`,
          )
          .then(({ data }) => (this.formData = data))
          .finally(() => (this.loading = false));
      }
    },
  },
  computed: {
    ...mapGetters(['locale']),
    answers() {
      return this.value.answers
        .filter(({ answer }) => answer !== null && answer !== undefined)
        .map((answer) => {
          const questionNames = answer.question.translations.reduce(
            (acc, item) => {
              acc[item.locale] = item.title;
              return acc;
            },
            {},
          );
          return {
            id: answer.id,
            question:
              questionNames[this.locale] ??
              questionNames['de'] ??
              questionNames['en'],
            answer: answer.answer,
          };
        });
    },
  },
};
</script>
